import {
  Semanticpmpmvt7fldq2 as Semantic,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
  get_H4Semantic111wmmqwoslob as get_H4Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import {
  User8yb1tqk4kykg as User,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
  Projecto73xqbcrzskm as Project,
  LineItem2rt64afaiyloc as LineItem,
  Contractor1wog4uk4l8u77 as Contractor,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_viewingAnonymousProjects1fofp0ylcs0e6 as get_viewingAnonymousProjects } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1ahgushtajx2d as title_0,
} from '../../theming/Titles.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { debounce3uffs71hj1o26 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  report3fj81patexuuw as report,
  get_issues1z1skb5sgeygq as get_issues,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Invalid2lchzzxcoxbzy as Invalid } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  ReactiveLoading_getInstance37x995i6zd62h as ReactiveLoading_getInstance,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Action1a4ymn5nx79hk as Action } from '../../../utils/utils.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { validategsg6go7eyi9d as validate } from '../../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  maybeSpecCenteredText3k2zk0rmdqomq as maybeSpecCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  h33vrlzi8yr34xu as h3,
  text1v7b2bj2gx49v as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Canvas2ofr7h6unhudb as Canvas } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Canvas.commonHtml.mjs';
import { ProgressDelegate2saexiliay2do as ProgressDelegate } from '../../components/ProgressDelegate.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import {
  get_windowIsNarrow3aab1t9rdaelq as get_windowIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../components/nav/crowpay.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { keyString2x2ocg778b9mu as keyString } from '../../components/keyValue.mjs';
import { PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { get_AutoRoutes3nqqi7p59slz8 as get_AutoRoutes } from '../../autoroutes.mjs';
import { Companion_getInstance3qvaw4651ntmp as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AnonymousProjectView24hg9uw1el0c2 as AnonymousProjectView } from '../common/AnonymousProjectView.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_partyq13c2hdc8rqy as get_party,
  get_state3dimnrbngbj36 as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import {
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
  PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je as PaymentState_AwaitingConfirmation_getInstance,
  ProjectState_Terminated_getInstancedn60ew509y4p as ProjectState_Terminated_getInstance,
  ProjectState_Cancelled_getInstanceoirlccakusgk as ProjectState_Cancelled_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathNotInSet2lprzz67ddi7c as xDataClassPathNotInSet,
  inside3oxyfk5qky4sm as inside,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import {
  andvtrcuje7baox as and,
  Companion_instancek13g6rikuawd as Companion_instance,
  andNotNull1zuhbghcdslbi as andNotNull,
  And3abx79zpqd7r8 as And,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  get_customer1w9vmrtgthst as get_customer,
  get_state23zbf4that7g as get_state_0,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  get_project15zbqkhtwq5i6 as get_project,
  get_cancelled2dthnu39zs2ql as get_cancelled,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { get__id44zpbhzp4qxe as get__id } from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { generalToDos3v1z2jqg8nvlm as generalToDos } from '../common/GeneralToDos.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from './ClientProject.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ClientDashboard$Companion$SnapShotSemantic$default$lambda($this$to, it) {
  return it.ab1_1;
}
function ClientDashboard$Companion$SnapShotSemantic$default$lambda_0($this$to, it) {
  return it.ab1_1;
}
var SnapShotSemanticClass;
function SnapShotSemantic() {
  if (SnapShotSemanticClass === VOID) {
    class $ extends Semantic() {
      static rj1() {
        SnapShotSemantic_instance = null;
        var $this = this.dd1('snpsht');
        SnapShotSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = theme.fb1(CardSemantic_getInstance()).gb1_1;
        var tmp_0 = HoverSemantic_getInstance();
        var tmp_1 = to(tmp_0, ClientDashboard$Companion$SnapShotSemantic$default$lambda);
        var tmp_2 = DownSemantic_getInstance();
        return tmp.td1(this.cd1_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_1, to(tmp_2, ClientDashboard$Companion$SnapShotSemantic$default$lambda_0)])).ab1_1;
      }
    }
    initMetadataForObject($, 'SnapShotSemantic');
    SnapShotSemanticClass = $;
  }
  return SnapShotSemanticClass;
}
var SnapShotSemantic_instance;
function SnapShotSemantic_getInstance() {
  if (SnapShotSemantic_instance === VOID)
    SnapShotSemantic().rj1();
  return SnapShotSemantic_instance;
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var removed = ArrayList().w();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fj2_1.tj1_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.crowpay.utils.associateWithNotNull' call
  var this_2 = tmp_0;
  var map = LinkedHashMap().fc(this_2.p1());
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp_1;
    try {
      // Inline function 'kotlin.collections.getOrPut' call
      var this_3 = $this.fj2_1.uj1_1;
      var value = this_3.p3(item);
      var tmp_2;
      if (value == null) {
        var tmp_3 = session.vfw().rfg_1.gfp(item, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var answer = tmp_3;
        this_3.s3(item, answer);
        tmp_2 = answer;
      } else {
        tmp_2 = value;
      }
      tmp_1 = tmp_2;
    } catch ($p) {
      var tmp_4;
      if ($p instanceof LsErrorException()) {
        var e = $p;
        var containsArg = e.wdr_1.o4b_1;
        if (!(400 <= containsArg ? containsArg <= 499 : false))
          throw e;
        // Inline function 'kotlin.collections.plusAssign' call
        removed.v(item);
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_4;
    }
    var value_0 = tmp_1;
    if (!(value_0 == null)) {
      // Inline function 'kotlin.collections.set' call
      map.s3(item, value_0);
    }
  }
  var info = map;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!removed.i1()) {
    // Inline function 'com.crowpay.utils.modify2' call
    var this_4 = session.afw_1.geo(session.gfv_1);
    // Inline function 'com.lightningkite.lightningdb.modification' call
    // Inline function 'kotlin.apply' call
    var this_5 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_5 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$9);
    this_5.g44(get_viewingAnonymousProjects(it), removed);
    var tmp$ret$14 = this_5.m1r();
    var tmp_6 = this_4.nen(tmp$ret$14, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
  }
  return info;
}
function ClientDashboard$render$slambda$lambda($this$dialog, close) {
  var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(35));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$dialog.pc());
  var tmp0_elvis_lhs = $this$dialog.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
  $this$dialog.gbb(p, view);
  view.zbm(true);
  title(view, 'Join Project');
  body(view, 'Enter the project link below (provided by the contractor).');
  var plink = validated(Signal().hak(''));
  var deb = debounce(plink, 500n);
  reactive(view, ($this$reactive) => {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = $this$reactive.daj(deb);
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (!(charSequenceLength(this_0) === 0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var d = tmp_0;
    var parsed = render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$parse_7oudno(d);
    var tmp_1;
    if (parsed == null) {
      report(plink, new (Invalid())('Invalid Link'));
      tmp_1 = Unit_instance;
    } else {
      report(plink, null);
      tmp_1 = Unit_instance;
    }
    return Unit_instance;
  });
  var viewProject = Action('View Project', VOID, ClientDashboard$render$slambda$lambda$slambda_0(view, plink, close));
  // Inline function 'com.crowpay.views.components.field2' call
  var label = 'Project Link';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_0, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_0 = view_0.jbb(FieldSemantic_getInstance());
  var tmp_1 = validate(view_0, plink);
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextInput())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zah(view_1.icn_1, plink);
  view_1.obg(viewProject);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_1, view_1);
  var tmp$ret$7 = issueText(view_0, get_issues(plink));
  view_0.lbb(tmp_0, tmp$ret$7);
  view_0.lbb(view_0.jbb(SubtextSemantic_getInstance()), errorText(view_0));
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view.pc(), 0.5);
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view.hbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.zbm(false);
  var tmp_2 = get_primaryButton(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = $this$reactiveScope.daj(deb);
    if (!isBlank(this_1)) {
      tmp = $this$reactiveScope.daj(get_issues(plink)).i1();
    } else {
      tmp = false;
    }
    var tmp$ret$17 = tmp;
    this_0.set(tmp$ret$17);
    return Unit_instance;
  });
  specCenteredText(view_4, 'View Project');
  view_4.obg(viewProject);
  view_3.hbb(p_4, view_4);
  view_3.lbb(tmp_2, view_4);
  var tmp_5 = get_textButton(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Button())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  specCenteredText(view_5, 'Go Back');
  onClick(view_5, VOID, VOID, ClientDashboard$render$slambda$lambda$slambda_2(close));
  view_3.hbb(p_5, view_5);
  view_3.lbb(tmp_5, view_5);
  view.hbb(p_3, view_3);
  $this$dialog.hbb(p, view);
  return $this$dialog.lbb(tmp, view);
}
var ClientDashboard$render$slambda$lambda$slambdaClass;
function ClientDashboard$render$slambda$lambda$slambda() {
  if (ClientDashboard$render$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, $plink, $close) {
        this.gj2_1 = $$this$col;
        this.hj2_1 = $plink;
        this.ij2_1 = $close;
      }
      yah($this$Action, $completion) {
        var tmp = get_pageNavigator(this.gj2_1);
        var tmp0_elvis_lhs = render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$parse_7oudno(this.hj2_1.f2());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.fbw(tmp_0);
        this.ij2_1();
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientDashboard$render$slambda$lambda$slambdaClass = $;
  }
  return ClientDashboard$render$slambda$lambda$slambdaClass;
}
function ClientDashboard$render$slambda$lambda$slambda_0($$this$col, $plink, $close) {
  var i = new (ClientDashboard$render$slambda$lambda$slambda())($$this$col, $plink, $close);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ClientDashboard$render$slambda$lambda$slambdaClass_0;
function ClientDashboard$render$slambda$lambda$slambda_1() {
  if (ClientDashboard$render$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.jj2_1 = $close;
      }
      uao($completion) {
        this.jj2_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientDashboard$render$slambda$lambda$slambdaClass_0 = $;
  }
  return ClientDashboard$render$slambda$lambda$slambdaClass_0;
}
function ClientDashboard$render$slambda$lambda$slambda_2($close) {
  var i = new (ClientDashboard$render$slambda$lambda$slambda_1())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var ProjectSnapshotClass;
function ProjectSnapshot() {
  if (ProjectSnapshotClass === VOID) {
    class $ {
      constructor(project, items, contractor) {
        this.kj2_1 = project;
        this.lj2_1 = items;
        this.mj2_1 = contractor;
      }
      toString() {
        return 'ProjectSnapshot(project=' + this.kj2_1.toString() + ', items=' + toString(this.lj2_1) + ', contractor=' + this.mj2_1.toString() + ')';
      }
      hashCode() {
        var result = this.kj2_1.hashCode();
        result = imul(result, 31) + hashCode(this.lj2_1) | 0;
        result = imul(result, 31) + this.mj2_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectSnapshot()))
          return false;
        if (!this.kj2_1.equals(other.kj2_1))
          return false;
        if (!equals(this.lj2_1, other.lj2_1))
          return false;
        if (!this.mj2_1.equals(other.mj2_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ProjectSnapshot');
    ProjectSnapshotClass = $;
  }
  return ProjectSnapshotClass;
}
function projectSnapshot($this, _this__u8e3s4, snapshot, to) {
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.gba(get_AppDimensions().zg1_1);
  view.bb9(get_AppDimensions().zg1_1);
  view.kbw(to);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.lbb(get_centered(view_1), h3(view_1, snapshot.kj2_1.b7b_1));
  view_1.lbb(get_centered(view_1), body(view_1, '-'));
  view_1.lbb(view_1.kbb(get_centered(view_1), view_1.jbb(ProjectStateSemantic().eh1(snapshot.kj2_1.u7b_1))), body(view_1, snapshot.kj2_1.u7b_1.u9b_1));
  view_0.hbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().jg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowCollapsingToColumn())(view_0.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  var tmp = weight(view_2, 1.5);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SnapShotSemantic_getInstance()));
  view_3.gba(get_AppDimensions().zg1_1);
  var tmp_0 = get_centered(view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(HeaderSemantic_getInstance().abf(get_H4Semantic())));
  view_5.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Project Progress';
  var tmp_1 = view_5.vb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = value;
  }
  tmp_1.hbu(tmp_2);
  view_4.hbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.zbm(true);
  view_6.bb9(get_px(0));
  var tmp0 = snapshot.lj2_1;
  var tmp$ret$11;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(tmp0, Collection())) {
      tmp_3 = tmp0.i1();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$11 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.w6k_1 == null)) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$11 = count;
  }
  var done = tmp$ret$11;
  var tmp_4 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.canvas' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Canvas())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  view_7.tbi(ProgressDelegate().yga(AppColors_getInstance().ffz_1.zg9_1, done / snapshot.lj2_1.p1()));
  view_6.hbb(p_7, view_7);
  view_6.lbb(tmp_4, view_7);
  smallBody(view_6, '' + done + '/' + snapshot.lj2_1.p1() + ' work items met');
  view_4.hbb(p_6, view_6);
  view_3.hbb(p_4, view_4);
  view_3.lbb(tmp_0, view_4);
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp, view_3);
  var tmp_5 = weight(view_2, 1.5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_8 = view_2.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_2 : tmp0_elvis_lhs_8;
  view_2.gbb(p_8, view_8);
  view_8.zbm(true);
  var tmp_6 = KMutableProperty0();
  var tmp_7 = RowOrCol$_get_vertical_$ref_sb5wat(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('vertical', 0, tmp_6, tmp_7, RowOrCol$_set_vertical_$ref_crf5qp(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp$ret$27 = !$this$reactiveScope.daj(get_windowIsNarrow());
    this_0.set(tmp$ret$27);
    return Unit_instance;
  });
  var tmp_8 = get_expanding(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Frame())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  view_9.lba(view_9.qb6_1.abf(SnapShotSemantic_getInstance()));
  var tmp_9 = get_centered(view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.gbb(p_10, view_10);
  view_10.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.lba(view_11.qb6_1.abf(HeaderSemantic_getInstance().abf(get_H4Semantic())));
  view_11.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = 'Project Balance';
  var tmp_10 = view_11.vb5_1;
  var tmp_11;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_11 = '\xA0';
  } else {
    tmp_11 = value_0;
  }
  tmp_10.hbu(tmp_11);
  view_10.hbb(p_11, view_11);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.gbb(p_12, view_12);
  view_12.lba(view_12.qb6_1.abf(BodySemantic_getInstance()));
  view_12.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_1 = MonetaryValue__toString_impl_xslc77(snapshot.kj2_1.u97());
  var tmp_12 = view_12.vb5_1;
  var tmp_13;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_1) === 0) {
    tmp_13 = '\xA0';
  } else {
    tmp_13 = value_1;
  }
  tmp_12.hbu(tmp_13);
  view_10.hbb(p_12, view_12);
  view_9.hbb(p_10, view_10);
  view_9.lbb(tmp_9, view_10);
  view_8.hbb(p_9, view_9);
  view_8.lbb(tmp_8, view_9);
  var tmp_14 = get_expanding(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (Frame())(view_8.pc());
  var tmp0_elvis_lhs_13 = view_8.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_8 : tmp0_elvis_lhs_13;
  view_8.gbb(p_13, view_13);
  view_13.lba(view_13.qb6_1.abf(SnapShotSemantic_getInstance()));
  var tmp_15 = get_centered(view_13);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_14.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (TextView())(view_14.pc());
  var tmp0_elvis_lhs_15 = view_14.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.gbb(p_15, view_15);
  view_15.lba(view_15.qb6_1.abf(HeaderSemantic_getInstance().abf(get_H4Semantic())));
  view_15.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_2 = 'Funds Released';
  var tmp_16 = view_15.vb5_1;
  var tmp_17;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_2) === 0) {
    tmp_17 = '\xA0';
  } else {
    tmp_17 = value_2;
  }
  tmp_16.hbu(tmp_17);
  view_14.hbb(p_15, view_15);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (TextView())(view_14.pc());
  var tmp0_elvis_lhs_16 = view_14.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
  view_14.gbb(p_16, view_16);
  view_16.lba(view_16.qb6_1.abf(BodySemantic_getInstance()));
  view_16.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_3 = MonetaryValue__toString_impl_xslc77(snapshot.kj2_1.c7c_1);
  var tmp_18 = view_16.vb5_1;
  var tmp_19;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_3) === 0) {
    tmp_19 = '\xA0';
  } else {
    tmp_19 = value_3;
  }
  tmp_18.hbu(tmp_19);
  view_14.hbb(p_16, view_16);
  view_13.hbb(p_14, view_14);
  view_13.lbb(tmp_15, view_14);
  view_8.hbb(p_13, view_13);
  view_8.lbb(tmp_14, view_13);
  view_2.hbb(p_8, view_8);
  view_2.lbb(tmp_5, view_8);
  var tmp_20 = weight(view_2, 2.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_17 = view_2.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_2 : tmp0_elvis_lhs_17;
  view_2.gbb(p_17, view_17);
  view_17.zbm(true);
  view_17.lba(view_17.qb6_1.abf(SnapShotSemantic_getInstance()));
  view_17.bb9(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (TextView())(view_17.pc());
  var tmp0_elvis_lhs_18 = view_17.ebb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
  view_17.gbb(p_18, view_18);
  view_18.lba(view_18.qb6_1.abf(HeaderSemantic_getInstance().abf(get_H4Semantic())));
  view_18.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_4 = snapshot.mj2_1.b5j_1.toString() + ' Information';
  var tmp_21 = view_18.vb5_1;
  var tmp_22;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_4) === 0) {
    tmp_22 = '\xA0';
  } else {
    tmp_22 = value_4;
  }
  tmp_21.hbu(tmp_22);
  view_17.hbb(p_18, view_18);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (RowOrCol())(view_17.pc());
  var tmp0_elvis_lhs_19 = view_17.ebb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_17 : tmp0_elvis_lhs_19;
  view_17.gbb(p_19, view_19);
  view_19.zbm(true);
  keyString(view_19, 'Name', snapshot.mj2_1.v5i_1);
  keyString(view_19, 'Address', snapshot.mj2_1.z5i_1.toString());
  keyString(view_19, 'Email', snapshot.mj2_1.x5i_1);
  // Inline function 'kotlin.let' call
  var it = snapshot.mj2_1.y5i_1;
  var tmp_23 = PhoneNumberFormat_USA_getInstance();
  // Inline function 'kotlin.text.filter' call
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().d1();
  var inductionVariable = 0;
  var last = charSequenceLength(it);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element_0 = charSequenceGet(it, index);
      if (isDigit(element_0)) {
        destination.xb(element_0);
      }
    }
     while (inductionVariable < last);
  var tmp$ret$84 = destination.toString();
  var tmp$ret$86 = tmp_23.adb(tmp$ret$84);
  keyString(view_19, 'Phone', tmp$ret$86);
  view_17.hbb(p_19, view_19);
  view_2.hbb(p_17, view_17);
  view_2.lbb(tmp_20, view_17);
  view_0.hbb(p_2, view_2);
  view.hbb(p_0, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$parse_7oudno(_this__u8e3s4) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = get_AutoRoutes().zd6(Companion_getInstance().dd7(substringAfter_0(substringAfter(_this__u8e3s4, '://'), _Char___init__impl__6a9atx(47))));
  var tmp;
  if (this_0 instanceof AnonymousProjectView()) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function ClientDashboard$viewingAnonymousProjects$lambda($this$remember) {
  return $this$remember.daj($this$remember.daj(get_session()).rfw_1).s88_1;
}
var ClientDashboard$anonymousProjectInfo$slambdaClass;
function ClientDashboard$anonymousProjectInfo$slambda() {
  if (ClientDashboard$anonymousProjectInfo$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.fj2_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientDashboard$anonymousProjectInfo$slambdaClass = $;
  }
  return ClientDashboard$anonymousProjectInfo$slambdaClass;
}
function ClientDashboard$anonymousProjectInfo$slambda_0(this$0) {
  var i = new (ClientDashboard$anonymousProjectInfo$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function ClientDashboard$awaitingRefunds$lambda($this$remember) {
  var tmp = $this$remember.daj(get_session()).sfv_1;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp$ret$3 = and(eq(get_party(it), Party_Client_getInstance()), eq(get_state(it), PaymentState_AwaitingConfirmation_getInstance()));
  var tmp$ret$4 = new (Query())(tmp$ret$3, orderBy, 0, 100);
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this$remember.daj(tmp.heo(tmp$ret$4));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$5 = item.o7k_1;
    destination.v(tmp$ret$5);
  }
  return toSet(destination);
}
function ClientDashboard$filteredProjects$lambda$lambda(it) {
  return it.u7b_1;
}
function ClientDashboard$filteredProjects$lambda$lambda_0(it) {
  return it.b7b_1;
}
function ClientDashboard$render$lambda($this$title) {
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
  reactiveScope($this$title, ($this$reactiveScope) => {
    var tmp$ret$0 = get_fullName($this$reactiveScope.daj($this$reactiveScope.daj(get_session()).rfw_1));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ClientDashboard$render$slambdaClass;
function ClientDashboard$render$slambda() {
  if (ClientDashboard$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        var tmp = get_dialogStack();
        tmp.vh2(VOID, VOID, ClientDashboard$render$slambda$lambda);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientDashboard$render$slambdaClass = $;
  }
  return ClientDashboard$render$slambdaClass;
}
function ClientDashboard$render$slambda_0() {
  var i = new (ClientDashboard$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function RowOrCol$_get_vertical_$ref_sb5wat(p0) {
  return () => p0.wb8_1;
}
function RowOrCol$_set_vertical_$ref_crf5qp(p0) {
  return (_this__u8e3s4) => {
    p0.zbm(_this__u8e3s4);
    return Unit_instance;
  };
}
var ClientDashboardClass;
function ClientDashboard() {
  if (ClientDashboardClass === VOID) {
    class $ {
      constructor() {
        this.sj1_1 = new (Constant())(_Constant___init__impl__v45mub('Home'));
        var tmp = this;
        tmp.tj1_1 = remember(VOID, VOID, VOID, ClientDashboard$viewingAnonymousProjects$lambda);
        this.uj1_1 = HashMap().n8();
        var tmp_0 = this;
        tmp_0.vj1_1 = rememberSuspending(VOID, VOID, VOID, ClientDashboard$anonymousProjectInfo$slambda_0(this));
        this.wj1_1 = Signal().hak(false);
        var tmp_1 = this;
        tmp_1.xj1_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.daj(get_session());
          var showAll = $this$remember.daj(this.wj1_1);
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$1 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$1);
          var tmp$ret$3 = andNotNull(Companion_instance, [eq(get_customer(it), session.gfv_1), showAll ? null : xDataClassPathNotInSet(get_state_0(it), setOf([ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance()]))]);
          var tmp$ret$4 = new (Query())(tmp$ret$3, orderBy, 0, 100);
          return session.rfv_1.heo(tmp$ret$4);
        });
        var tmp_2 = this;
        tmp_2.yj1_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.xj1_1)));
        var tmp_3 = this;
        tmp_3.zj1_1 = remember(VOID, VOID, VOID, ClientDashboard$awaitingRefunds$lambda);
        var tmp_4 = this;
        tmp_4.aj2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var hasRefunds = $this$remember.daj(this.zj1_1);
          var tmp2 = $this$remember.daj(this.yj1_1);
          // Inline function 'com.crowpay.views.screens.client.ClientDashboard.filterIf' call
          var tmp;
          if (!$this$remember.daj(this.wj1_1)) {
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp2.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.u7b_1.d4(ProjectState_Complete_getInstance()) < 0 || hasRefunds.t1(element.v7a_1)) {
                destination.v(element);
              }
            }
            tmp = destination;
          } else {
            tmp = tmp2;
          }
          var tmp_0 = tmp;
          var tmp_1 = (it) => !hasRefunds.t1(it.v7a_1);
          var tmp_2 = ClientDashboard$filteredProjects$lambda$lambda;
          return sortedWith(tmp_0, compareBy([tmp_1, tmp_2, ClientDashboard$filteredProjects$lambda$lambda_0]));
        });
        var tmp_5 = this;
        tmp_5.bj2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(this.yj1_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$9 = item.v7a_1;
            destination.v(tmp$ret$9);
          }
          var projects = destination;
          var tmp = $this$remember.daj(get_session()).ofv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$12 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$12);
          var tmp_1 = inside(get_project(it), projects);
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$21 = eq(get_cancelled(it_0), null);
          return $this$remember.daj(tmp.heo(new (Query())(And().u3q(listOf_0([tmp_1, tmp$ret$21])))));
        });
        var tmp_6 = this;
        tmp_6.cj2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(this.yj1_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$22 = item.x7a_1;
            destination.v(tmp$ret$22);
          }
          var ids = destination;
          var tmp = $this$remember.daj(get_session()).lfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$26 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$26);
          var tmp$ret$28 = inside(get__id(it), ids);
          var tmp$ret$29 = new (Query())(tmp$ret$28, orderBy, 0, 100);
          // Inline function 'kotlin.collections.associateBy' call
          var this_1 = $this$remember.daj(tmp.heo(tmp$ret$29));
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
          // Inline function 'kotlin.collections.associateByTo' call
          var destination_0 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_0 = this_1.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            var tmp$ret$30 = element.t5i_1;
            destination_0.s3(tmp$ret$30, element);
          }
          return destination_0;
        });
        var tmp_7 = this;
        tmp_7.dj2_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(this.vj1_1).r3();
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$33 = new (ProjectSnapshot())(item.w9w_1, item.z9w_1, item.y9w_1);
            destination.v(tmp$ret$33);
          }
          return destination;
        });
        var tmp_8 = this;
        tmp_8.ej2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var projects = $this$remember.daj(this.aj2_1);
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.bj2_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.f6k_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var groupedItems = destination;
          var contractors = $this$remember.daj(this.cj2_1);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(projects, 10));
          var _iterator__ex2g4s_0 = projects.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            var tmp0_elvis_lhs = groupedItems.p3(item.v7a_1);
            var tmp_0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var tmp1_elvis_lhs = contractors.p3(item.x7a_1);
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              LogRoot_getInstance().icv(['No contractor found for project ' + item.b7b_1 + ', loading...']);
              throw ReactiveLoading_getInstance();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }
            var tmp$ret$42 = new (ProjectSnapshot())(item, tmp_0, tmp_1);
            destination_0.v(tmp$ret$42);
          }
          return destination_0;
        });
      }
      wcv() {
        return this.sj1_1;
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_dp(0));
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        generalToDos(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        var tmp_1 = get_expanding(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().jg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        var tmp_2 = get_expanding(view_2);
        view_2.lbb(tmp_2, title_0(view_2, ClientDashboard$render$lambda));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(false);
        var tmp_3 = get_centered(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Checkbox())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zah(view_4.ebk_1, this.wj1_1);
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_3, view_4);
        view_3.lbb(get_centered(view_3), text(view_3, 'Show Past Projects'));
        view_2.hbb(p_3, view_3);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_1, view_2);
        var tmp_4 = view_1.kbb(get_centered(view_1), get_textButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.gbb(p_5, view_5);
        maybeSpecCenteredText(view_5, 'Join Project');
        onClick(view_5, VOID, VOID, ClientDashboard$render$slambda_0());
        view_1.hbb(p_5, view_5);
        view_1.lbb(tmp_4, view_5);
        view_0.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.gbb(p_6, view_6);
        view_6.zbm(true);
        forEach(view_6, this.dj2_1, ($this$forEach, snapshot) => {
          var tmp = get_section($this$forEach);
          $this$forEach.lbb(tmp, projectSnapshot(this, $this$forEach, snapshot, () => {
            // Inline function 'kotlin.apply' call
            var this_0 = new (AnonymousProjectView())(snapshot.kj2_1.v7a_1);
            var tmp0_safe_receiver = this.uj1_1.p3(snapshot.kj2_1.v7a_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              set_value(this_0.of1_1, tmp0_safe_receiver);
            }
            return this_0;
          }));
          return Unit_instance;
        });
        view_0.hbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_7 = view_0.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_0 : tmp0_elvis_lhs_7;
        view_0.gbb(p_7, view_7);
        view_7.zbm(true);
        forEach(view_7, this.ej2_1, ($this$forEach, snapshot) => {
          var tmp = get_section($this$forEach);
          $this$forEach.lbb(tmp, projectSnapshot(this, $this$forEach, snapshot, () => new (ClientProject())(snapshot.kj2_1.v7a_1)));
          return Unit_instance;
        });
        view_0.hbb(p_7, view_7);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    initMetadataForClass($, 'ClientDashboard', ClientDashboard, VOID, [Page()]);
    ClientDashboardClass = $;
  }
  return ClientDashboardClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  ClientDashboard as ClientDashboard2uxyaz2oxv2st,
};
//endregion

//# sourceMappingURL=ClientDashboard.mjs.map
